/**
 * Created by DejanK on 1/18/2017.
 */
import angular from 'angular'

import rbFloat from './rb-float.cmp'

export default angular.module('rb.float', [])
  .component('rbFloat', rbFloat)
